import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import type { AssetsStatusesEntry } from '@features/asset-management/asset-management.types';
import { AssetStatus } from '@features/asset-management/asset-management.types';
import type { NewInvestigationFormValues } from '@features/investigations/components/modals/add-new-investigation/investigation.schema';
import type { GenericMultiSelectOption } from '@shared/components/ui/custom';

import type { NewInvestigationPayload } from '../../../api/files.types';

dayjs.extend(utc);

type InvestigationTargetKeys = 'userName' | 'systemName' | 'ipAddress';

const TARGET_TYPE_MAP: Record<string, InvestigationTargetKeys> = {
  user: 'userName',
  host: 'systemName',
  ip: 'ipAddress',
};

export function mapFormValuesToPayload(data: NewInvestigationFormValues) {
  const dateFrom = data.dateRange?.from?.toISOString() ?? '';
  const dateTo = data.dateRange?.to?.toISOString() ?? '';

  const payload: NewInvestigationPayload = {
    traceName: data.traceName,
    dateFrom,
    dateTo,
    sendEmailNotification: true,
    assets: data.assets,
    reservationId: data.reservationId,
  };

  data.targets.forEach((target) => {
    const backendKey = TARGET_TYPE_MAP[target.type];
    if (backendKey) {
      payload[backendKey] = target.value;
    }
  });

  return payload;
}

export function getAssetOptions(assets: AssetsStatusesEntry[]): GenericMultiSelectOption[] {
  return [...assets]
    .sort((a, b) => {
      const diff = Number(a.status !== AssetStatus.READY) - Number(b.status !== AssetStatus.READY);
      return diff || a.name.localeCompare(b.name);
    })
    .map((asset) => ({
      value: asset.name,
      label: asset.name,
      disabled: asset.status !== AssetStatus.READY,
    }));
}
